import axios from 'axios'
import ZJConfig from '../../config'
import utils from '../../utils'

function rspSuccess(r) {
    return r && r.data && r.data.RspCode == '1'
}

function _ok(r, resolve, reject) {
    if (rspSuccess(r)) {
        r.success = true;
        r.RspCode = r.data.RspCode;
        r.RspMsg = r.data.RspMsg;
        resolve.apply(this, [r])
    }
    else {
        r.success = false;
        r.RspCode = r.data ? r.data.RspCode : null;
        r.RspMsg = r.data ? r.data.RspMsg : null;
        reject.apply(this, [r])
    }
}

function _fail(e, reject) {
    console.error(e);
    let r = e.response || {
        config: e.config,
        data: null,
        headers: {},
        request: e.request,
        status: 0,
        statusText: null
    };
    r.success = false;
    r.RspCode = r.data ? r.data.RspCode : null;
    r.RspMsg = r.data ? r.data.RspMsg : null;
    r.isAxiosError = e.isAxiosError;
    r.axiosMessage = e.message;
    r.axiosStack = e.stack;
    reject.apply(this, [r])
}

var ZJApi = function(opts) {
    this.init(opts)
}

var pt = ZJApi.prototype

pt.$class_name = 'ZJApi'
pt.base_url = ''
pt.service = ''
pt.version = ''
pt.controller = ''
pt.axiosConfig = {
    responseType: 'json'
}

pt.init = function(opts) {
    if (typeof opts === 'string')
        opts = { service: opts }
    opts = opts || {}
    if (opts.base_url)
        this.base_url = opts.base_url
    if (opts.service)
        this.service = opts.service
    if (opts.version)
        this.version = opts.version
    if (opts.controller)
        this.controller = opts.controller
    if (opts.axiosConfig)
        this.axiosConfig = utils.extend(
            this.axiosConfig || {},
            opts.axiosConfig)
}

// 构建完整的 Url
pt.buildUrl = function (path) {
    if (typeof path === 'function')
        return path.call(this)

    var base_url = this.base_url || ZJConfig.current.getValue('api.base_url', ''),
        version = this.version || ZJConfig.current.getValue('api.version', '1.0'),
        service = this.service || '',
        controller = this.controller || '',
        url = base_url

    // 移除尾部斜杠
    if (url && url[url.length - 1] == '/')
        url = url.substr(0, url.length - 1)

    if (service) {
        url += '/msapi/v' + (version || '1.0') + '/' + service
    }

    path = path || ''

    // 如果 controller 有值，且 path 中不包含 '/'，则添加 controller
    if (controller && path.indexOf('/') == -1)
        url += '/' + controller

    // 补齐 path 头部的斜杠
    if (!path || path[0] != '/')
        path = '/' + path

    url += path
    
    return url
}

// 构建数据
pt.buildData = function (data) {
    if (typeof data === 'function')
        return data.call(this)
    return data
}

// 使用 GET 方式调用 Api
pt.get = function (path, data, axiosConfig) {
    var that = this
    if (typeof axiosConfig === 'function')
        axiosConfig = axiosConfig.call(this)
    return new Promise(function (resolve, reject) {
        var cnf = utils.extend({},
            that.axiosConfig || {},
            {
                method: 'get'
            },
            axiosConfig || {},
            {
                url: that.buildUrl(path),
                params: that.buildData(data)
            })
        axios(cnf)
        .then(
            r => _ok(r, resolve, reject),
            e => _fail(e, reject))
    })
}

// 使用 POST 方式调用 Api
pt.post = function (path, data, axiosConfig) {
    var that = this
    if (typeof axiosConfig === 'function')
        axiosConfig = axiosConfig.call(this)
    return new Promise(function (resolve, reject) {
        var cnf = utils.extend({},
            that.axiosConfig || {},
            {
                method: 'post'
            },
            axiosConfig || {},
            {
                url: that.buildUrl(path),
                data: that.buildData(data)
            })
        axios(cnf)
        .then(
            r => _ok(r, resolve, reject),
            e => _fail(e, reject))
    })
}

// 定义一个新的 API
ZJApi.defineNewApi = function(class_name, opts) {
    let ZJCustomApi = function() {
        pt.init.apply(this, arguments)
    }
    ZJCustomApi.prototype = new ZJApi()
    ZJCustomApi.prototype.$class_name = class_name
    if (typeof opts === 'object') {
        utils.extend(ZJCustomApi.prototype, opts)
    }
    else if (typeof opts === 'function') {
        let factory = opts
        factory.call(ZJCustomApi, ZJCustomApi)
    }
    return ZJCustomApi
}

export default ZJApi
